import { render, staticRenderFns } from "./OrdersAll.vue?vue&type=template&id=58eaa82c"
import script from "./OrdersAll.vue?vue&type=script&lang=js"
export * from "./OrdersAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports